export const userDetailsTab = [
    { label: 'Personal Information' },
    { label: 'Bank Details' },
    { label: 'Onboarding Details' },
    { label: 'Work Experience' },
    { label: 'Uploaded Documents' }
]